import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  containerCards: {
    alignSelf: "center",
    marginTop: 20,
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
  },
  card: {
    marginBottom: 20,
    width: "100%",
    maxWidth: 320,
    padding: 16,
    borderWidth: 0.5,
    borderColor: "#FFF",
    borderRadius: 8,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 4,
    backgroundColor: "#FFF",
  },

  lblInfo: {
    fontWeight: "bold",
    fontSize: 16,
    color: "#000",
    marginBottom: 4,
    marginTop: 12,
  },

  row: {
    width: "100%",
    alignSelf: "flex-start",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    marginBottom: 10,
  },
  column: {
    flex: 1,
  },
  bankIcon: {
    width: 24,
    height: 24,
    marginLeft: "auto",
  },
});

export default styles;
